export const breakpoints = {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
};
export const mediaQuery = {
    up: ({ breakpoint, vertical = false }) => `@media (min-${vertical ? 'height' : 'width'}: calc(${breakpoints[breakpoint]} + 0.02px))`,
    down: ({ breakpoint, vertical = false }) => `@media (max-${vertical ? 'height' : 'width'}: ${breakpoints[breakpoint]})`,
    between: ({ breakpointMin, breakpointMax, vertical = false }) => `@media (max-${vertical ? 'height' : 'width'}: ${breakpoints[breakpointMax]}) and (min-${vertical ? 'height' : 'width'}: calc(${breakpoints[breakpointMin]} + 0.02px))`
};
